import { FC } from 'react';
// component
import DashboardContent from 'components/main/Dashboard';

const Dashboard: FC = () => <DashboardContent />;

export default Dashboard;
